
<p-dialog header="Subscription Required" [(visible)]="showSubscriptionlWarning" [style]="{width: '45vw'}" [baseZIndex]="10000"  [modal]="true">
  <div style="width:17%; float:left;">
    <img src="https://dashboard.wannabook.online/assets/images/email.png" style="width: 100%;">
    <div style="width:100%;margin-top:10px;"></div>
  </div>
  <div class="field mb-4 col-12" style="float:left;width:80%">
    <p>You need to be subsribed to one of our Communication products to use this feature<br><br>
    Clicking the button below will take you to our Additional Products page, once you are subscribed to a Communications product, you can return to this page and try again.</p>
  </div>
  <ng-template #footer>
    <p-button icon="pi pi-shopping-bag" label="Subscribe" styleClass="p-button p-button-success" (click)="subscribe()"></p-button>
  </ng-template>
</p-dialog>

<!-- ── Mobile view ─────────────────────────────────────────── -->
@if (useMobileView && ListBookings) {
  <div>
    <!-- Toolbar -->
    <div class="bb-mob-toolbar">
      <div class="bb-mob-toolbar-inner">
        <span class="bb-mob-title">{{displayDate}}</span>
        <div class="bb-mob-toolbar-actions">
          <button pButton type="button" class="p-button-sm p-button-outlined bb-mob-icon-btn"
            (click)="refreshList()" pTooltip="Refresh">
            <span class="pi pi-refresh"></span>
          </button>
          <button pButton type="button" class="p-button-sm p-button-outlined bb-mob-icon-btn"
            (click)="returnToList()">
            <span class="pi pi-angle-left" style="margin-right:4px;"></span>At a Glance
          </button>
        </div>
      </div>
    </div>
    <!-- Table -->
    <div class="surface-card shadow-2">
      <p-table [value]="ListBookings"
        sortField="startTime"
        [paginator]="true" [rows]="10"
        [showCurrentPageReport]="true"
        currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
        [rowsPerPageOptions]="[10,25,50]"
        [globalFilterFields]="['name','bookingId','bookingIdHR','packageName']"
        responsiveLayout="scroll"
        styleClass="mob-booking-table">
        <ng-template #header>
          <tr>
            <th class="mob-stripe-th"></th>
            <th pSortableColumn="startTime">Booking</th>
            <th pSortableColumn="total" style="text-align:right">Amount</th>
            <th style="width:48px"></th>
          </tr>
        </ng-template>
        <ng-template #body let-data>
          @if (!data.inProgress && !inProgress) {
            <tr [ngStyle]="{'background-color': data.disabled ? '#fff1f2' : ((data.allergy != null && data.allergy != '') ? '#FFFFB2' : '#ffffff')}"
              class="mob-data-row"
              (click)="editdatanew(data.bookingId)">
              <td class="mob-status-stripe"
                [ngStyle]="{'background-color': data.disabled ? '#ef4444' : (data.checkedin ? '#22c55e' : ((data.allergy != null && data.allergy != '') ? '#d97706' : '#94a3b8'))}">
              </td>
              <td class="mob-main-cell">
                <div class="mob-main-line1">
                  <span class="mob-time">{{data.startTime | date:'HH:mm' : 'UTC'}}</span>
                  <span class="mob-name">{{data.name}}</span>
                  <span class="mob-inline-icons">
                    @if (data.publicBooking) {
                      <i   class="pi pi-user               mob-iico"></i>
                    }
                    @if (data.awaitingpayment) {
                      <i class="pi pi-dollar             mob-iico mob-iico--red" pTooltip="Payment link sent"></i>
                    }
                    @if (data.notes) {
                      <i           class="pi pi-exclamation-circle  mob-iico mob-iico--red" [pTooltip]="data.notes"></i>
                    }
                    @if (data.checkedin) {
                      <i       class="pi pi-check-circle       mob-iico mob-iico--green"></i>
                    }
                    @if (data.allergy) {
                      <i         class="pi pi-star               mob-iico mob-iico--amber"></i>
                    }
                  </span>
                </div>
                <div class="mob-main-line2">
                  <span class="mob-bookingid">{{data.bookingIdHR}}</span>
                  @if (data.packageName) {
                    <span class="mob-pkg">&nbsp;&middot;&nbsp;{{data.packageName}}</span>
                  }
                  @if (data.guests) {
                    <span class="mob-guests">&nbsp;&middot;&nbsp;{{data.guests}} guest{{data.guests != 1 ? 's' : ''}}</span>
                  }
                </div>
              </td>
              <td class="mob-money-cell">
                <div class="mob-total">{{data.total | currency: (data.currency || CurrencySymbol)}}</div>
                <div [class.mob-os--overdue]="data.outstanding > 0" [class.mob-os--paid]="data.outstanding <= 0">
                  {{data.outstanding | currency: (data.currency || CurrencySymbol)}}
                </div>
              </td>
              <td class="mob-action-cell" (click)="$event.stopPropagation()">
                <button pButton type="button"
                  class="p-button-text p-button-plain mob-action-btn"
                  (click)="selectedAction = data; bbRowActionPanel.toggle($event)" [iconOnly]="true"><span class="p-button-icon pi pi-ellipsis-v" aria-hidden="true"></span></button>
                </td>
              </tr>
            }
          </ng-template>
        </p-table>
      </div>
      <p-popover #bbRowActionPanel appendTo="body">
        <ng-template pTemplate>
          <div class="mob-action-list">
            <button pButton type="button" class="p-button-outlined mob-action-item"
              (click)="editdatanew($safeNavigationMigration(selectedAction?.bookingId)); bbRowActionPanel.hide()"><span class="p-button-icon p-button-icon-left pi pi-pencil" aria-hidden="true"></span><span class="p-button-label">Edit Booking</span></button>
              @if (useCounters) {
                @if (!selectedAction?.checkedin && !selectedAction?.haswaiver) {
                  <button pButton type="button" class="p-button-outlined p-button-success mob-action-item"
                    [disabled]="!isBookingDateToday"
                    (click)="admitall($safeNavigationMigration(selectedAction?.bookingId)); bbRowActionPanel.hide()"><span class="p-button-icon p-button-icon-left pi pi-sign-in" aria-hidden="true"></span><span class="p-button-label">Admit</span></button>
                  }
                  @if (!selectedAction?.checkedin && selectedAction?.haswaiver) {
                    <button pButton type="button" class="p-button-outlined p-button-success mob-action-item"
                      [disabled]="!isBookingDateToday"
                      (click)="getToManageWaivers($safeNavigationMigration(selectedAction?.bookingId)); bbRowActionPanel.hide()"><span class="p-button-icon p-button-icon-left pi pi-sign-in" aria-hidden="true"></span><span class="p-button-label">Admit (Waiver)</span></button>
                    }
                    @if (selectedAction?.checkedin) {
                      <button pButton type="button" class="p-button-outlined p-button-danger mob-action-item"
                        [disabled]="!isBookingDateToday"
                        (click)="leaveall($safeNavigationMigration(selectedAction?.bookingId)); bbRowActionPanel.hide()"><span class="p-button-icon p-button-icon-left pi pi-sign-out" aria-hidden="true"></span><span class="p-button-label">Leave</span></button>
                      }
                    }
                  </div>
                </ng-template>
              </p-popover>
            </div>
          }

          <!-- ── Desktop view (unchanged) ──────────────────────────── -->
          @if (!useMobileView && ListBookings) {
            <div class="p-3 flex flex-column flex-auto">
              <div class="flex align-items-center justify-content-between mb-3">
                <h3 style="margin-bottom:0;">Bookings for {{displayDate}}</h3>
                <div>
                  <button pButton type="button" class="p-button p-button-sm p-button-outlined"
                    (click)="refreshList()"
                    pTooltip="Refresh Data"
                    style="margin-right: 10px;">
                    <span class="pi pi-refresh"></span>
                  </button>
                  <button pButton type="button" class="p-button p-button-sm p-button-outlined"
                    (click)="returnToList()"
                    pTooltip="Return to At a Glance">
                    <span class="pi pi-angle-left" style="margin-right:8px;"></span>
                    <span>Return to At a Glance</span>
                  </button>
                </div>
              </div>
              <div style="width:100%">
                <div style="float:right; margin-bottom: 20px;">
                  <span class="p-input-icon-left ml-auto" style="margin-right:20px; ">
                    <i class="pi pi-search"></i>
                    <input pInputText type="text" (input)="resourceTable.filterGlobal($event.target.value, 'contains')" style="height: 50px;padding-left:33px;" placeholder="Sales ID/Name"/>
                  </span>
                </div>
              </div>
              <div class="surface-card p-4 shadow-2 border-round">
                <p-table  #resourceTable
                  [columns]="cols"
                  [value]="ListBookings" sortField="startTime" [paginator]="true" [rows]="10"
                  [showCurrentPageReport]="true" responsiveLayout="scroll"
                  currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
                  [rowsPerPageOptions]="[10,25,50]"
                  [globalFilterFields]="['name', 'bookingId', 'bookingIdHR', 'packageName']"
                  [(selection)]="selectedItems"
                  responsiveLayout="scroll"
                  [selectionPageOnly]="true"
                  sortField="name" [sortOrder]="1"
                  [customSort]="true"
                  (sortFunction)="customSort($event)"
                  >
                  <ng-template #caption>
                    <div class="flex">
                      <button
                        type="button"
                        pButton
                        pRipple
                        (click)="resourceTable.exportCSV()"
                        class="mr-2"
                        pTooltip="Export to CSV"
                        tooltipPosition="bottom" [iconOnly]="true"><span class="p-button-icon pi pi-file-excel" aria-hidden="true"></span></button>
                        &nbsp;
                        <!-- <button
                        type="button"
                        pButton
                        pRipple
                        (click)="refreshData()"
                        class="mr-2 p-button-info"
                        pTooltip="Refresh Data"
                        tooltipPosition="bottom" [iconOnly]="true"><span class="p-button-icon pi pi-refresh" aria-hidden="true"></span></button> -->
                      </div>
                    </ng-template>
                    <ng-template #header>
                      <tr>
                        <th width="1%">
                          &nbsp;
                        </th>
                        <th width="1%">
                          &nbsp;
                        </th>
                        <th width="1%">
                          &nbsp;
                        </th>
                        <th pSortableColumn="bookingId" width="8%">Sales ID
                          <p-sorticon [field]="bookingIdHR"></p-sorticon>
                        </th>
                        <th pSortableColumn="startTime" width="10%">Start Date
                          <p-sorticon [field]="startTime"></p-sorticon>
                        </th>
                        <th pSortableColumn="startTime" width="3%">Start
                          <p-sorticon [field]="startTime"></p-sorticon>
                        </th>
                        <th pSortableColumn="name" width="10%">Name
                          <p-sorticon [field]="name"></p-sorticon>
                        </th>
                        <th pSortableColumn="name" width="18%">Admissions
                          <p-sorticon [field]="admissions"></p-sorticon>
                        </th>
                        <th pSortableColumn="packageName" width="13%">Package
                          <p-sorticon [field]="packageName"></p-sorticon>
                        </th>
                        <th pSortableColumn="resourcestring" width="10%">Resource
                          <p-sorticon field="resourcestring"></p-sorticon>
                        </th>
                        <th pSortableColumn="guests" width="6%">Guests
                          <p-sorticon [field]="guests"></p-sorticon>
                        </th>
                        <th pSortableColumn="total" width="5%">Total
                          <p-sorticon [field]="total"></p-sorticon>
                        </th>
                        <th pSortableColumn="outstanding" width="5%">O/S
                          <p-sorticon [field]="outstanding"></p-sorticon>
                        </th>
                        <th width="15%">
                          Extras
                        </th>
                        <th width="10%">
                          Allergy
                        </th>
                        <th>
                        </th>
                        @if (useCounters) {
                          <th width="5%"></th>
                        }
                      </tr>
                    </ng-template>
                    <ng-template #body let-data>
                      @if (!data.inProgress && !inProgress  && (data.allergy == '' || data.allergy == null)) {
                        <tr onmouseover="this.originalstyle=this.style.backgroundColor;this.style.backgroundColor='#dddddd'" onmouseout="this.style.backgroundColor=this.originalstyle;" [ngStyle]="{'background-color': (data.disabled==true) ? '#fee' : '#ffffff'}">
                          <td (click)="editdatanew(data.bookingId)" >
                            @if (data.publicBooking) {
                              <span class="pi pi-user"></span>
                            }
                          </td>
                          <td (click)="editdatanew(data.bookingId)">
                            @if (data.notes != '' && data.notes != null) {
                              <span style="color:red" class="pi pi-exclamation-circle" pTooltip="{{data.notes}}"></span>
                            }
                          </td>
                          <td>
                            @if (data.awaitingpayment) {
                              <span style="color:red" class="pi pi-dollar" pTooltip="A payment link has been sent for this booking."></span>
                            }
                          </td>
                          <td (click)="editdatanew(data.bookingId)">{{data.bookingIdHR}}</td>
                          <td (click)="editdatanew(data.bookingId)">{{data.startTime | date:'dd/MM/yy'}}</td>
                          <td (click)="editdatanew(data.bookingId)">{{data.startTime | date:'HH:mm' : 'UTC'}}</td>
                          <td (click)="editdatanew(data.bookingId)">{{data.name}} ({{maskMobile(data.phone)}})</td>
                          <td (click)="editdatanew(data.bookingId)">{{data.admissions}}</td>
                          <!-- <td (click)="editdatanew(data.bookingId)">{{data.email}}</td>
                          <td (click)="editdatanew(data.bookingId)">{{data.phone}}</td> -->
                          <td (click)="editdatanew(data.bookingId)">{{data.packageName}}</td>
                          <td (click)="editdatanew(data.bookingId)">{{data.resourcestring}}</td>
                          <td (click)="editdatanew(data.bookingId)">{{data.guests}}</td>
                          <td (click)="editdatanew(data.bookingId)">{{data.total | currency: (data.currency || CurrencySymbol)}}</td>
                          @if (data.outstanding <=0) {
                            <td (click)="editdatanew(data.bookingId)">{{data.outstanding | currency: (data.currency || CurrencySymbol)}}</td>
                          }
                          @if (data.outstanding >0) {
                            <td (click)="editdatanew(data.bookingId)"><span style="color: Red; font-weight: bold;">{{data.outstanding | currency: (data.currency || CurrencySymbol)}}</span></td>
                          }
                          <td (click)="editdatanew(data.bookingId)">{{data.extrastext}}</td>
                          <td (click)="editdatanew(data.bookingId)">{{data.allergy}}</td>
                          <!-- <td>
                          <button *ngIf="data.haswaiver" pButton type="button" class="p-button-sm p-element p-ripple p-button-success p-button p-component" style="width:145px; margin-right: -20px;" (click)="getToManageWaivers(data.bookingId)">
                            <span class="pi pi-file-pdf" style="margin-right:8px;"></span>
                            <span>View Waiver</span>
                          </button>
                          <button *ngIf="!data.haswaiver" disabled="true" pButton type="button" class="p-button-sm p-element p-ripple p-button-success p-button p-component" style="width:145px; margin-right: -20px;">
                            <span class="pi pi-file-pdf" style="margin-right:8px;"></span>
                            <span>View Waiver</span>
                          </button>
                        </td> -->
                        @if (useCounters) {
                          <td>
                            @if (!data.checkedin && data.haswaiver) {
                              <button pButton type="button" class="p-button-sm p-element p-ripple p-button-success p-button p-component" style="width:100px;" [disabled]="!isBookingDateToday" (click)="getToManageWaivers(data.bookingId)">
                                <span class="pi pi-sign-in" style="margin-right:8px;"></span>
                                <span>Admit</span>
                              </button>
                            }
                            @if (!data.checkedin && !data.haswaiver) {
                              <button pButton type="button" class="p-button-sm p-element p-ripple p-button-success p-button p-component" style="width:100px;" [disabled]="!isBookingDateToday" (click)="admitall(data.bookingId)">
                                <span class="pi pi-sign-in" style="margin-right:8px;"></span>
                                <span>Admit</span>
                              </button>
                            }
                            @if (data.checkedin) {
                              <button pButton type="button" class="p-button-sm p-element p-ripple p-button-danger p-button p-component" style="width:100px;" [disabled]="!isBookingDateToday" (click)="leaveall(data.bookingId)">
                                <span class="pi pi-sign-out" style="margin-right:8px;"></span>
                                <span>Leave</span>
                              </button>
                            }
                          </td>
                        }
                      </tr>
                    }
                    @if (!data.inProgress && !inProgress && data.allergy != '' && data.allergy != null) {
                      <tr onmouseover="this.originalstyle=this.style.backgroundColor;this.style.backgroundColor='#dddddd'" onmouseout="this.style.backgroundColor=this.originalstyle;" [ngStyle]="{'background-color': (data.disabled==true) ? '#fee' : '#FFFFB2'}">
                        <td (click)="editdatanew(data.bookingId)" >
                          @if (data.publicBooking) {
                            <span class="pi pi-user"></span>
                          }
                        </td>
                        <td (click)="editdatanew(data.bookingId)">
                          @if (data.notes != '' && data.notes != null) {
                            <span style="color:red" class="pi pi-exclamation-circle" pTooltip="{{data.notes}}"></span>
                          }
                        </td>
                        <td>
                          @if (data.awaitingpayment) {
                            <span style="color:red" class="pi pi-dollar" pTooltip="A payment link has been sent for this booking."></span>
                          }
                        </td>
                        <td (click)="editdatanew(data.bookingId)">{{data.bookingIdHR}}</td>
                        <td (click)="editdatanew(data.bookingId)">{{data.startTime | date:'dd/MM/yy'}}</td>
                        <td (click)="editdatanew(data.bookingId)">{{data.startTime | date:'HH:mm' : 'UTC'}}</td>
                        <td (click)="editdatanew(data.bookingId)">{{data.name}} ({{maskMobile(data.phone)}})</td>
                        <td (click)="editdatanew(data.bookingId)">{{data.admissions}}</td>
                        <!-- <td (click)="editdatanew(data.bookingId)">{{data.email}}</td>
                        <td (click)="editdatanew(data.bookingId)">{{data.phone}}</td> -->
                        <td (click)="editdatanew(data.bookingId)">{{data.packageName}}</td>
                        <td (click)="editdatanew(data.bookingId)">{{data.resourcestring}}</td>
                        <td (click)="editdatanew(data.bookingId)">{{data.guests}}</td>
                        <td (click)="editdatanew(data.bookingId)">{{data.total | currency: (data.currency || CurrencySymbol)}}</td>
                        @if (data.outstanding <=0) {
                          <td (click)="editdatanew(data.bookingId)">{{data.outstanding | currency: (data.currency || CurrencySymbol)}}</td>
                        }
                        @if (data.outstanding >0) {
                          <td (click)="editdatanew(data.bookingId)"><span style="color: Red; font-weight: bold;">{{data.outstanding | currency: (data.currency || CurrencySymbol)}}</span></td>
                        }
                        <td (click)="editdatanew(data.bookingId)">{{data.extraslist}}</td>
                        <td (click)="editdatanew(data.bookingId)">{{data.allergy}}</td>
                        <td>
                          @if (data.haswaiver) {
                            <button pButton type="button" class="p-button-sm p-element p-ripple p-button-success p-button p-component" style="width: 145px; margin-right: -20px;" (click)="getToManageWaivers(data.bookingId)">
                              <span class="pi pi-file-pdf" style="margin-right:8px;"></span>
                              <span>View Waiver</span>
                            </button>
                          }
                        </td>
                        @if (useCounters) {
                          <td>
                            @if (!data.checkedin) {
                              <button pButton type="button" class="p-button-sm p-element p-ripple p-button-success p-button p-component" style="width:100px;" [disabled]="!isBookingDateToday" (click)="admitall(data.bookingId)">
                                <span class="pi pi-sign-in" style="margin-right:8px;"></span>
                                <span>Admit</span>
                              </button>
                            }
                            @if (data.checkedin) {
                              <button pButton type="button" class="p-button-sm p-element p-ripple p-button-danger p-button p-component" style="width:100px;" [disabled]="!isBookingDateToday" (click)="leaveall(data.bookingId)">
                                <span class="pi pi-sign-out" style="margin-right:8px;"></span>
                                <span>Leave</span>
                              </button>
                            }
                          </td>
                        }
                      </tr>
                    }
                  </ng-template>
                </p-table>
                <div>
                  <div class="field mb-4 col-12">
                    <label for="" class="font-medium">Send this email to all bookings in this time slot: </label><br>
                    @if (ShowDynamicTextEditor) {
                      <div>
                        <div class="surface-card p-4 shadow-2 border-round">
                          <h5>Email Preview</h5>
                          <div style="overflow-x: hidden; height: calc(75vh - 348px)">
                            <div [innerHTML]="ExampleEmail | safe: 'html'">
                            </div>
                          </div>
                          @if (ShowDynamicContent) {
                            <div>
                              <div class="field mb-4 col-12">
                                <p>Please fill out the text for each of your dynamic text areas</p>
                              </div>
                              @for (c of dynamicTextArray; track c) {
                                <div  class="field mb-4 col-12" style="margin-top: -40px; width:100%;">
                                  <label for="template" class="font-medium">Dynamic Text {{c.index}}</label>
                                  <br>
                                    <textarea pInputText [(ngModel)]="c.text" style="width:100%"></textarea>
                                  </div>
                                }
                                <p-button icon="pi pi-check" label="Save Text" styleClass="p-button p-button-success" (click)="SaveText()"></p-button>
                                &nbsp;
                                <p-button icon="pi pi-times" label="Cancel" styleClass="p-button p-button-danger"  (click)="CancelText()"></p-button>
                              </div>
                            }
                            @if (!ShowDynamicContent) {
                              <div style="margin-top:20px;">
                                <p-button icon="pi pi-pencil" label="Show Dynamic Content Fields" styleClass="p-button p-button-danger"  (click)="showDynamicText()"></p-button>
                              </div>
                            }
                            <div style="clear:both;"></div>
                          </div>
                          <br>
                          </div>
                        }
                        <p-select [options]="EmailTemplates" [style]="{'width': '300px', 'float': 'left'}"  placeholder="Select a template" [showClear]="true" [(ngModel)]="selectedEmailTemplate" optionLabel="name" (onChange)="changeTemplate()"></p-select>
                      </div>
                      <div style="width: 100px; float: left; margin-top: -32px; margin-left: 10px;">
                        <p-button icon="pi pi-send" label="Send" styleClass="p-button p-button-success" (click)="sendEmailToAllBookings()"></p-button>
                      </div>
                    </div>
                    @if (!templateValid) {
                      <div class="text-danger" Style="clear:both; width:100%"><span class="pi pi-exclamation-triangle" style="margin-right:5px;"></span>You must select a Template.</div>
                    }
                  </div>
                </div>
              }
